import { render, staticRenderFns } from "./ChallengesPage.vue?vue&type=template&id=09491e38&"
import script from "./ChallengesPage.vue?vue&type=script&lang=js&"
export * from "./ChallengesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports